//@ts-nocheck
import CTABtn from './cta-btn';
import styles from './modal.module.css';
import { FaCheck } from "react-icons/fa6";
export default function Modal({ handleSubmit }){
    return <div className={styles.container}>
        <div className={styles.block}>
            <div>
                Thank you, your privacy request has been received. 
            </div>
            <CTABtn btnName="Ok" btnURL="/home" passedFunction={handleSubmit}/>
        </div>
    </div>
}